import { SiteType } from '@/gql/graphql';
import { hasSMOValues } from '@/types';

export const formatSiteName = (
  name: string,
  organization?: string | null,
  siteType?: SiteType | null,
  hasMultiple?: boolean | null,
  country?: string | null,
  city?: string | null,
  state?: string | null
) => {
  if (!organization) {
    return name;
  }
  if (siteType) {
    switch (siteType) {
      case SiteType.Hospital:
      case SiteType.Amc:
        return organization ? `${organization} | ${name}` : name;
      case SiteType.PrivatePractice:
        if (hasMultiple) {
          return `${organization} | ${name}`;
        } else {
          if (country && state && city) {
            if (country === 'United States of America') {
              if (state) {
                return `${organization} | ${city}, ${stateAbbreviationUS[state]}`;
              }
              return name;
            } else {
              return `${organization} | ${city}, ${country}`;
            }
          }
          return name;
        }
      default:
        return name;
    }
  }
  return name;
};

export const mapHasSMO = (hasSmo: string | undefined) => {
  if (!hasSmo) {
    return undefined;
  }

  if (hasSmo === hasSMOValues.yes) {
    return true;
  }

  if (hasSmo === hasSMOValues.no) {
    return false;
  }

  if (hasSmo === hasSMOValues.notSure) {
    return null;
  }

  return undefined;
};

export const stateAbbreviationUS = {
  Alaska: 'AK',
  Alabama: 'AL',
  Arkansas: 'AR',
  Arizona: 'AZ',
  California: 'CA',
  Colorado: 'CO',
  Connecticut: 'CT',
  'District of Columbia': 'DC',
  Delaware: 'DE',
  Florida: 'FL',
  Georgia: 'GA',
  Hawaii: 'HI',
  Iowa: 'IA',
  Idaho: 'ID',
  Illinois: 'IL',
  Indiana: 'IN',
  Kansas: 'KS',
  Kentucky: 'KY',
  Louisiana: 'LA',
  Massachusetts: 'MA',
  Maryland: 'MD',
  Maine: 'ME',
  Michigan: 'MI',
  Minnesota: 'MN',
  Missouri: 'MO',
  Mississippi: 'MS',
  Montana: 'MT',
  'North Carolina': 'NC',
  'North Dakota': 'ND',
  Nebraska: 'NE',
  'New Hampshire': 'NH',
  'New Jersey': 'NJ',
  'New Mexico': 'NM',
  Nevada: 'NV',
  'New York': 'NY',
  Ohio: 'OH',
  Oklahoma: 'OK',
  Oregon: 'OR',
  Pennsylvania: 'PA',
  'Puerto Rico': 'PR',
  'Rhode Island': 'RI',
  'South Carolina': 'SC',
  'South Dakota': 'SD',
  Tennessee: 'TN',
  Texas: 'TX',
  Utah: 'UT',
  Virginia: 'VA',
  'U.S. Virgin Islands': 'VI',
  Vermont: 'VT',
  Washington: 'WA',
  Wisconsin: 'WI',
  'West Virginia': 'WV',
  Wyoming: 'WY',
};
